import { useQuery } from "@tanstack/react-query"

import {
  createPrayerReminderSetting,
  deletePrayerReminderSetting,
  editPrayerReminderSetting,
  getPrayerReminderMeta,
  getPrayerReminderSettings,
} from "api/prayerReminderApi"
import {
  useCreateResource,
  useDeleteResource,
  useEditResource,
  usePaginatedResource,
} from "./useCrudResource"

export const PRAYER_REMINDER_QUERY_KEY = "prayer-reminders"

export const usePrayerReminderSettings = (params = {}, enabled = true) =>
  usePaginatedResource(
    PRAYER_REMINDER_QUERY_KEY,
    getPrayerReminderSettings,
    params,
    enabled
  )

export const usePrayerReminderMeta = (enabled = true) =>
  useQuery({
    queryKey: [PRAYER_REMINDER_QUERY_KEY, "meta"],
    queryFn: getPrayerReminderMeta,
    enabled,
    staleTime: 10 * 60 * 1000,
  })

export const useCreatePrayerReminderSetting = () =>
  useCreateResource(createPrayerReminderSetting, PRAYER_REMINDER_QUERY_KEY)

export const useEditPrayerReminderSetting = () =>
  useEditResource(editPrayerReminderSetting, PRAYER_REMINDER_QUERY_KEY)

export const useDeletePrayerReminderSetting = () =>
  useDeleteResource(deletePrayerReminderSetting, PRAYER_REMINDER_QUERY_KEY)
